import styled from 'styled-components'

import { helpers } from 'styles'

export const Hint = styled.div`
	text-align: right;
	width: 100%;
	font-weight: 400;
	color: ${helpers.color.textMuted};
	align-self: flex-end;
`
